import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import InnerHeader from '../InnerHeader/InnerHeader'
import ContactSection from './ContactSection'

function ContactPage() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);
    return (
        <>
            {loading ? (
                <div className="load-main" >
                    <div className="loading">
                        <span className="loader"></span>
                        <span className="loader"></span>
                        <span className="loader"></span>
                        <span className="loader"></span>
                    </div>
                </div>
            ) : (
                <div className='ContactPage_main'>
                    <InnerHeader
                        Heading="Contact"
                    />
                    <ContactSection />
                    <div className="social_main">
                        <div className="container">
                            <div className="wrapper">
                                <p className="desc heading_LB">Follow Us on Social Media</p>
                                <div className="btn_main">
                                    <ul className="btn_otr">
                                        <li className="btn_inr btn1">
                                            <Link className="heading_SB social_linkk">Facebook</Link>
                                        </li>
                                        <li className="btn_inr btn2">
                                            <Link className="heading_SB social_linkk">Twitter</Link>
                                        </li>
                                        <li className="btn_inr btn3">
                                            <Link className="heading_SB social_linkk">Instagram</Link>
                                        </li>
                                        <li className="btn_inr btn4">
                                            <Link className="heading_SB social_linkk">WhatsApp</Link>
                                        </li>
                                        <li className="btn_inr btn5">
                                            <Link className="heading_SB social_linkk">Telegram</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ContactPage